import {common} from "../proto/compiled";
import moment from "moment-timezone";

export class DateUtils {
  static getDatePickerFormat(granularity?: common.DateGranularity | null): string {
    switch (granularity) {
    case common.DateGranularity.year:
      return 'YYYY';
    case common.DateGranularity.month:
      return 'MM. YYYY';
    case common.DateGranularity.day:
      return 'DD. MM. YYYY';
    case common.DateGranularity.hour:
      return 'DD. MM. YYYY ob HH';
    case common.DateGranularity.minute:
      return 'DD. MM. YYYY ob HH:mm';
    case common.DateGranularity.second:
      return 'DD. MM. YYYY ob HH:mm:ss';
    default:
      return 'DD. MM. YYYY';
    }
  }

  static toString(obj?: common.IDate | null, objTo?: common.IDate): string {
    if (!obj) {
      return "";
    }
    const format = DateUtils.getDatePickerFormat(obj.granularity);
    let ts;
    // on the server side, the timestamp is a Long object
    // @ts-ignore
    if (obj.ts['toNumber'] !== undefined) {
      // @ts-ignore
      ts = obj.ts['toNumber']();
    } else {
      ts = obj.ts as number;
    }
    const start = moment(ts).format(format);
    if (objTo) {
      return `${start} - ${DateUtils.toString(objTo)}`;
    } else {
      return start;
    }
  }
}